import {Group, NavLink, ThemeIcon} from '@mantine/core';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {MainLinkProps} from 'src/types/interfaces/main-link';
import useTranslation from 'src/i18next.config';
import ConfirmationModal from 'src/components/core/ConfirmationModals';

function MainLink({
    icon,
    color,
    label,
    path,
    external,
    href,
    onAction,
    useLocationHref,
    confirmBeforeOpen,
    confirmMessage,
    rightSection,
    onNavigate,
}: MainLinkProps & {onNavigate?: () => void}) {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const [confirmOpen, setConfirmOpen] = useState(false);

    const performAction = async () => {
        if (onAction) {
            await onAction();
        } else if (useLocationHref && href) {
            window.location.href = href;
        } else if (external && href) {
            window.open(href, '_blank');
        } else {
            navigate(path);
        }
        onNavigate?.();
    };

    const handleClick = () => {
        if (confirmBeforeOpen) {
            setConfirmOpen(true);
        } else {
            performAction();
        }
    };

    const labelContent = rightSection ? (
        <Group gap="xs">
            <span>{label}</span>
            {rightSection}
        </Group>
    ) : (
        label
    );

    return (
        <>
            <NavLink
                label={labelContent}
                leftSection={
                    <ThemeIcon color={color} variant="light">
                        {icon}
                    </ThemeIcon>
                }
                onClick={handleClick}
            />
            <ConfirmationModal
                isOpen={confirmOpen}
                title={label}
                text={confirmMessage ?? t('externalLinkConfirmation')}
                onClose={() => setConfirmOpen(false)}
                onConfirmation={() => {
                    setConfirmOpen(false);
                    performAction();
                }}
            />
        </>
    );
}

export function MainLinks(props: {links: MainLinkProps[]; onNavigate?: () => void}) {
    return (
        <div>
            {props.links.map(link => (
                <MainLink {...link} key={link.label} onNavigate={props.onNavigate} />
            ))}
        </div>
    );
}
